import { getPayInfo, setPayInfo } from '@/utils/Address.js'
import {
  clearAddressCache,
  readAddressCache,
  writeAddressCache
} from '@/utils/addressStorage'

const storageGoodsInfo = {
  payInfo: [],
  payType: '',
  cartInfo: {} // key 是 goods_sn , value 是 card_id
}

// 设置优惠券
const Set_welfareCard = (state, info) => {
  state.welfareCard = info
}

// 清空优惠券
const clearWelfareCard = state => {
  state.welfareCard = {}
}

// 设置订单号
const Set_orderId = (state, info) => {
  state.orderId = info
}
// 设置蛋糕门店
const Set_cake_shop = (state, info) => {
  state.cakeShop = info
}

const clean_Cake_shop = state => {
  state.cakeShop = ''
}

// 设置配送方式
const set_cake_delivery = (state, info) => {
  state.cakeDelivery = info
}

const set_cake_tiemline = (state, info) => {
  state.caketimeline = info
}

// 设置支付方式
/**
 * @typedef {Object} payWay
 * @property {String} payWay.type - 支付类型 saas | cansh
 * @property {String} payWay.id - 支付方式 id
 */

// const set_pay_way = (state, { type, id }) => {
//   if ( (!type && type !== 'saas' || type !== 'cansh') || !id) {
//     return
//   }
//   // 限制payway 超出的长度 1 删除第一个
//   const hasWay = state.payWay[type].find(item => item === id)
//   if (state.payWay[type].length >= 1 && hasWay) {
//     state.payWay[type].shift()
//   } else {
//     state.payWay[type].push(id)
//   }
// }

const mutations = {
  /*
    写入地址详情, 同时同步 addressId 并落盘.
    走服务端默认地址时 addressId 原本是空的, 这里一并补上,
    否则刷新后又会重新拉默认地址.
  */
  setAddressInfo: (state, addressInfo) => {
    const info = addressInfo || {}
    state.addressInfo = info

    if (!info.address_id) return

    state.addressId = String(info.address_id)
    writeAddressCache({
      addressId: state.addressId,
      addressInfo: info
    })
  },
  /**
   * 设置选中地址
   * @param {string|number|{addressId: string, addressInfo: Object}} payload
   *        兼容只传 id 的旧调用方
   */
  SET_ADDRESSID: (state, payload) => {
    const isDetailPayload =
      payload !== null &&
      typeof payload === 'object' &&
      'addressId' in payload

    const addressId = isDetailPayload
      ? payload.addressId
      : payload
    const addressInfo = isDetailPayload
      ? payload.addressInfo
      : null

    if (!addressId) return

    state.addressId = String(addressId)

    if (addressInfo) {
      state.addressInfo = addressInfo
    }

    writeAddressCache({
      addressId: state.addressId,
      addressInfo: addressInfo || state.addressInfo
    })
  },
  GET_ADDRESSID: state => {
    return state.addressId
  },
  /*
    清空选中地址 —— 删除地址、退出登录时调用.
    必须同步清缓存, 否则刷新后死 id 会被重新 hydrate 回来.
  */
  CLEAN_ADDRESSID: state => {
    state.addressId = ''
    state.addressInfo = {}
    state.validatedAddressId = ''
    clearAddressCache()
  },
  // 启动时把本地缓存注入 state, 未命中缓存不做任何改动
  HYDRATE_ADDRESS: state => {
    const cache = readAddressCache()
    if (!cache) return

    state.addressId = cache.addressId
    state.addressInfo = cache.addressInfo
  },
  // 记录已通过服务端校验的地址 id, 避免重复校验
  SET_VALIDATED_ADDRESSID: (state, addressId) => {
    state.validatedAddressId = addressId
      ? String(addressId)
      : ''
  },
  // 设置支付信息
  /**
   * @typedef {Object} payInfo
   * @property {Array} payInfo - 支付信息
   * @property {String} payType - 支付类型 cart 购物车结算 buyNow 立即购买结算
   */
  SET_PAYINFO: (state, info) => {
    const {
      payInfo,
      payType,
      cartInfo,
      movieInfo,
      goods_type
    } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payType = payType

      if (goods_type && goods_type === 'movie') {
        console.log('movieInfo', movieInfo)
        state.movieInfo = movieInfo
        state.goodsType = 'movie'
      } else {
        state.movieInfo = {}
        state.goodsType = ''
      }
      console.log('state', state)

      if (cartInfo) {
        state.cartInfo = cartInfo
        storageGoodsInfo.cartInfo = cartInfo
      }

      storageGoodsInfo.payInfo = payInfo
      storageGoodsInfo.payType = payType

      setPayInfo(storageGoodsInfo)
    }
  },
  Set_welfareCard,
  clearWelfareCard,
  Set_orderId,
  Set_cake_shop,
  clean_Cake_shop
  // set_pay_way
}

export default mutations
